// extracted by mini-css-extract-plugin
export default {"sidebar":"CallingLineNavbar_sidebar__o9gpv","navbar":"CallingLineNavbar_navbar__+-eAM"};